import { Injectable } from '@angular/core';
import { IResourceFilesProvider } from 'app/interfaces/IResourceFilesProvider';
import { ILogger } from 'app/logger/ILogger';
import { BaseDataProviderService } from 'app/services/base-data-provider.service';
import { LocalResourceProviderService } from './local-resource-provider.service';
import { LoggerService } from 'app/logger/logger.service';
import { IdentityService } from 'app/model/services/identity.service';
import { PrimaryResourceUrlInformationService } from 'app/services/primary-resource-url-information.service';
import { FileClientProviderService } from './file-client-provider.service';
import { IResourceContext } from 'shell-models-lib';
import { ExposureControlService } from 'app/services/exposure-control/base-exposure-control.service';

@Injectable()
export class CmdApiDataProviderService extends BaseDataProviderService {
    private _resourceFilesProvider: IResourceFilesProvider;

    public setResourceFilesProvider(resourceFilesProvider: IResourceFilesProvider): void {
        this._resourceFilesProvider = resourceFilesProvider;
    }

    public getResourceFilesProvider(): IResourceFilesProvider {
        if (!this._resourceFilesProvider) {
            this._resourceFilesProvider = new LocalResourceProviderService(
                this._contextData,
                this._loggerService,
                this._fileClientProviderService,
                this._primaryResourceUrlService,
                this._identityService,
                this._exposureControlService
            );
        }

        return this._resourceFilesProvider;
    }

    public getLogger(): ILogger {
        return this._loggerService;
    }

    public isGitMode(): boolean {
        return false;
    }

    constructor(
        private _contextData: IResourceContext,
        private _loggerService: LoggerService,
        private _fileClientProviderService: FileClientProviderService,
        private _primaryResourceUrlService: PrimaryResourceUrlInformationService,
        private _identityService: IdentityService,
        private _exposureControlService: ExposureControlService
    ) {
        super();
    }
}
